/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseTreeStructureApi } from './BaseTreeStructureApi';
import { Observable } from 'rxjs';
import { InitiativeRating } from '../../../lib/wwg.classes';

export class InitiativeApi extends BaseTreeStructureApi {
  endPoint: string = '/api/admin/initiatives';

  public findByIdWithFiles(id: any): Observable<any> {
    const _routeParams = {
      id: id
    };
    return this._get(this.endPoint + '/:id?includeFiles=true', _routeParams);
  }

  public getUsers(initiativeIds: string[], isStaff?: boolean): Observable<any> {
    const params: Record<string, string | string[]> = {
      // Need to convert to array name, to ensure, single item is still treated as array
      'initiativeIds[]': initiativeIds,
    };

    if (isStaff !== undefined) {
      params.isStaff = String(isStaff);
    }

    return this._get(this.endPoint + '/users', {}, { params });
  }

  public listPortfolios(): Observable<any> {
    return this._get(this.endPoint + '/portfolios', {});
  }

  public listCompanies(): Observable<any> {
    return this._get(this.endPoint + '/companies', {});
  }

  /** Exclude value chain nodes */
  public listInitiativeNodes(): Observable<any> {
    return this._get(this.endPoint + '/companies/nodes', {});
  }

  public getAvailableTags() {
    return this._get(this.endPoint + '/tags', {});
  }

  public getAvailableOktaGroups() {
    return this._get(this.endPoint + '/okta/groups', {});
  }

  public getAvailableAppConfigs() {
    return this._get(this.endPoint + '/app-configs', {});
  }

  public getByIds(ids: string[]) {
    const uniqueIds = Array.from((new Set(ids)));
    return this.http.post(this._generateURL(this.endPoint + '/query'), { ids: uniqueIds });
  }

  public importRatings(code: string, ratings: InitiativeRating[]) {
    return this._patch(this.endPoint + '/code/:code/import-ratings', { code }, { ratings });
  }

  public combine(sourceId: string, destinationId: string): Observable<any> {
    return this._post(this.endPoint + '/combine/:sourceId/:destinationId', {
      sourceId, destinationId
    }, {});
  }
}
